import React from 'react';

/**
 * Shared footer region for the "default web" layout variants. The raw design
 * ships this region present but empty (its copyright/back-to-top markup is
 * commented out in the source) — kept as-is rather than inventing content the
 * design doesn't contain.
 */
export default function AppFooter() {
  return <footer className="pt-5 mt-5"></footer>;
}
